
import React from 'react';
import {
  Calculator,
  BarChart,
  Database,
  Warehouse,
  FileText,
  Sheet,
  MessageCircleHeart,
  ShoppingCart,
  ContactRound,
  Search,
  Code,
  DollarSign
} from 'lucide-react';

function Features() {
  const features = [
    {
      icon: <Calculator size={32} color="var(--marter-blue)" />,
      title: "Profit Calculators",
      description: "Use our profit calculators for resellers and private label to get a clear picture of your numbers.",
      footer: <div><img src="/logos/marter.png" style={{ width: "50%" }} /></div>,
      url: "https://www.getmarter.com/"
    },
    {
      icon: <Database size={32} color="var(--marter-blue)" />,
      title: "Historical Data",
      description: "Access all historical data, determine sales velocity, and set alerts for everything with our unique technology.",
      footer: <div><img src="/logos/histomart.png" style={{ width: "50%" }} /></div>,
      url: "https://www.histomart.com/"
    },
    {
      icon: <Warehouse size={32} color="var(--marter-blue)" />,
      title: "Inventory Management",
      description: "Manage your inventory: add items, convert to WFS, and create shipments in seconds.",
      footer: <div><img src="/logos/falcon.png" style={{ width: "90%" }} /></div>,
      url: "https://www.inventoryfalcon.com/"
    },
    {
      icon: <FileText size={32} color="var(--marter-blue)" />,
      title: "Reports",
      description: "Get P&L reports, insights, tracking, and everything you need to monitor and manage your store.",
      footer: <div><img src="/logos/falcon.png" style={{ width: "90%" }} /></div>,
      url: "https://www.inventoryfalcon.com/"
    },
    {
      icon: <Sheet size={32} color="var(--marter-blue)" />,
      title: "Wholesale Sourcing",
      description: "Analyze catalog and price list sheets in seconds with our CSV Scanner.",
      footer: <div><img src="/logos/aniseller.png" style={{ width: "50%" }} /></div>,
      url: "https://www.aniseller.com/"
    },
    {
      icon: <BarChart size={32} color="var(--marter-blue)" />,
      title: "Competition and Brand Analysis",
      description: "Get detailed reports and analysis on any brand on Walmart, understand your competition, and assess your position.",
      footer: <div></div>,
      url: ""
    },
    {
      icon: <MessageCircleHeart size={32} color="var(--marter-blue)" />,
      title: "Feedback Agent",
      description: "Automate reviews and feedback with our agent to quickly boost your sales.",
      footer: <div></div>,
      url: ""
    },
    {
      icon: <ShoppingCart size={32} color="var(--marter-blue)" />,
      title: "OA Sourcing",
      description: "Source online arbitrage faster with Marter's Online Arbitrage sourcing software.",
      footer: <div><img src="/logos/moa.png" style={{ width: "50%" }} /></div>,
      url: "https://www.marteroa.com/"
    },
    {
      icon: <ContactRound size={32} color="var(--marter-blue)" />,
      title: "Storefront Stalking",
      description: "Scan other storefronts, uncover trends, and gain insights in seconds. Stay ahead of your competition.",
      footer: <div></div>,
      url: ""
    },
    {
      icon: <Search size={32} color="var(--marter-blue)" />,
      title: "Marter Search Engine",
      description: "Scan Walmart's database with historical data to discover top-selling products in each category and more, all through our powerful search engine.",
      footer: <div></div>,
      url: ""
    },
    {
      icon: <DollarSign size={32} color="var(--marter-blue)" />,
      title: "Marter AI",
      description: "Coming Soon", //"Stay ahead of the competition, boost your profit margins, and secure the Buy Box automatically.",
      footer: <div></div>,
      url: ""
    },
    {
      icon: <Code size={32} color="var(--marter-blue)" />,
      title: "For Developers",
      description: "Leverage our API to build any tool you need, with access to all the information and historical data, plus an easy-to-use interface.",
      footer: <div></div>,
      url: ""
    }
  ];

  return (
    <section id="solutions" className="section section-padding has-background-marter-gray">
      <div className="container">
        <div className="has-text-centered mb-6">
          <h2 className="title is-2 has-text-marter-dark-blue mb-4">
            Solutions Designed for Your Success
          </h2>
          <p className="subtitle is-5 has-text-marter-dark-gray mb-6 mx-auto" style={{ maxWidth: "800px" }}>
            Our tools use cutting-edge technology to help you with every aspect of selling on Walmart, from start to finish. No more guesswork.
          </p>
        </div>

        <div class="bubble">
          Our solutions are tailored for Resellers, Private Label Brands, and Enterprises, including Agencies, Prep Centers, and Developers!
        </div>

        <div className="columns is-multiline">
          {features.map((feature, index) => (
            <div key={index} className="column is-12-mobile is-6-tablet is-4-desktop" onClick={() => feature.url ? window.open(feature.url) : alert("Email us at info@getmarter.com")}>
              <div className="card feature-card solutionCard" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <div className="card-content">
                  <div className="icon-bg">
                    {feature.icon}
                  </div>
                  <h3 className="title is-4 has-text-marter-dark-blue mb-3">
                    {feature.title}
                  </h3>
                  <p className="has-text-marter-dark-gray">
                    {feature.description}
                  </p>
                </div>
                <div style={{ marginTop: "auto", marginLeft: "5%" }}>{feature.footer}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Features;
